// 🧿 طلسم محافظ فایل

// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
// Local Components
import { OrderTableAdditional } from "./OrderTableAdditional";
// Requests
import { getOrderTable } from "src/Requests/automaticMarketMaking";
// Types
import {
  IOrderTableSearchParams,
  IOrderTableReport,
} from "src/Interfaces/automaticMarketMaking";

interface IProps {
  searchParam: IOrderTableSearchParams;
}

const OrderTable = ({ searchParam }: IProps) => {
  return (
    <div className="overflow-auto order-table w-full">
      <TableTemplate<IOrderTableSearchParams, IOrderTableReport>
        refreshTableTime={5000}
        withSort
        getDataTable={getOrderTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            sortingType={sortingType}
            setSortingType={setSortingType}
            AdditionalBody={OrderTableAdditional}
            tableBoxClassName="max-h-[300px]"
            withSelect
          />
        )}
        searchParameters={searchParam}
        showIsLoading={false}
      />
    </div>
  );
};

export default OrderTable;
